// Links de documento do Google (Docs/Sheets/Drive) só valem no Contexto do
// negócio do cliente — lá o conteúdo é lido e injetado na análise. Em comentários
// de ação são bloqueados. Espelha a validação do backend (src/services/contextDocs.ts).
const DOCUMENT_LINK_REGEX = /https?:\/\/(?:docs|drive)\.google\.com\/\S+/i

/** True se o texto contém um link de documento do Google. */
export function containsDocumentLink(text: string | null | undefined): boolean {
  if (!text) return false
  return DOCUMENT_LINK_REGEX.test(text)
}

export const DOC_LINK_IN_NOTE_MESSAGE =
  'Comentários não podem conter links de documentos (Google Docs/Sheets/Drive). ' +
  'Coloque o link no Contexto do negócio do cliente.'
